/**
 * @param activeFeature {featureInterface}
 * @param cartItems {[cartItemInterface]}
 * @param activeQuoteIndex {number}
 */
export const getPSADefaultQuantity = (activeFeature, cartItems, activeQuoteIndex) => {
  if (!activeFeature || !cartItems || !cartItems.length) {
    return 0
  }
  let topCabinets = {
    quantity: 0,
    sharedFeatureNames: [],
  };
  let bottomCabinets = {
    quantity: 0,
    sharedFeatureNames: [],
  };

  cartItems.forEach((cItem) => {
    if (cItem.currentQuote !== activeQuoteIndex) {
      return
    }
    if (cItem.partId === "top_cabinet") {
      topCabinets.quantity += cItem.quantity;
      if (!topCabinets.sharedFeatureNames.includes(cItem.cartFeature.dbFeature.sharedFeatureName)) {
        topCabinets.sharedFeatureNames.push(cItem.cartFeature.dbFeature.sharedFeatureName)
      }
    } else if (cItem.partId === "bottom_cabinet") {
      bottomCabinets.quantity += cItem.quantity;
      if (!bottomCabinets.sharedFeatureNames.includes(cItem.cartFeature.dbFeature.sharedFeatureName)) {
        bottomCabinets.sharedFeatureNames.push(cItem.cartFeature.dbFeature.sharedFeatureName)
      }
    }
  });
  const allMaterialsQuantity = topCabinets.quantity + bottomCabinets.quantity;
  const differentSharedFeatureNames =
    topCabinets.sharedFeatureNames.some(name => !bottomCabinets.sharedFeatureNames.includes(name))
    || bottomCabinets.sharedFeatureNames.some(name => !topCabinets.sharedFeatureNames.includes(name));

  const checkIfNotShowFeature = (group) => {
    if (activeFeature.dbFeature.sharedFeatureName === `4 x ${group} PSA Group E`) {
      if (!topCabinets.quantity || !bottomCabinets.quantity || differentSharedFeatureNames) {
        return true
      }
    } else if (activeFeature.dbFeature.sharedFeatureName === `4 x ${group} PSA Top Cabinet`) {
      if (!topCabinets.quantity || (topCabinets.quantity && bottomCabinets.quantity && !differentSharedFeatureNames)) {
        return true
      }
    } else if (activeFeature.dbFeature.sharedFeatureName === `4 x ${group} PSA Bottom Cabinet`) {
      if (!bottomCabinets.quantity || (topCabinets.quantity && bottomCabinets.quantity && !differentSharedFeatureNames)) {
        return true
      }
    }
    return false
  }

  switch (activeFeature.dbFeature.sharedFeatureName) {
    case "4 x 8 PSA Group E":
    case "4 x 8 PSA Top Cabinet":
    case "4 x 8 PSA Bottom Cabinet": {
      if (checkIfNotShowFeature("8")) {
        return 0
      }
      if (allMaterialsQuantity <= 40) {
        return 1
      } else if (allMaterialsQuantity <= 100) {
        return 0
      } else if (allMaterialsQuantity <= 130) {
        return 2
      } else if (allMaterialsQuantity <= 190) {
        return 1
      } else if (allMaterialsQuantity <= 280) {
        return 0
      } else if (allMaterialsQuantity <= 310) {
        return 1
      } else {
        return 0
      }
    }
    case "4 x 10 PSA Group E":
    case "4 x 10 PSA Top Cabinet":
    case "4 x 10 PSA Bottom Cabinet": {
      if (checkIfNotShowFeature("10")) {
        return 0
      }
      if (allMaterialsQuantity <= 40) {
        return 0
      } else if (allMaterialsQuantity <= 70) {
        return 1
      } else if (allMaterialsQuantity <= 130) {
        return 0
      } else if (allMaterialsQuantity <= 160) {
        return 1
      } else if (allMaterialsQuantity <= 190) {
        return 0
      } else if (allMaterialsQuantity <= 220) {
        return 2
      } else if (allMaterialsQuantity <= 250) {
        return 1
      } else {
        return 0
      }
    }
    case "4 x 12 PSA Group E":
    case "4 x 12 PSA Top Cabinet":
    case "4 x 12 PSA Bottom Cabinet": {
      if (checkIfNotShowFeature("12")) {
        return 0
      }
      if (allMaterialsQuantity <= 70) {
        return 0
      } else if (allMaterialsQuantity <= 100) {
        return 1
      } else if (allMaterialsQuantity <= 160) {
        return 0
      } else if (allMaterialsQuantity <= 190) {
        return 1
      } else if (allMaterialsQuantity <= 220) {
        return 0
      } else if (allMaterialsQuantity <= 250) {
        return 1
      } else if (allMaterialsQuantity <= 310) {
        return 2
      } else {
        return 0
      }
    }
    default:
      break;
  }
  return 0
}
